export const ENV = {
  dev: "dev",
  fat: "fat",
  stage: "stage",
  prod: "prod",
};
export const isProd = () => {
  return process.env.NEXT_PUBLIC_DEPLOY_ENV === ENV.prod;
};
